module.exports = __webpack_public_path__ + "static/media/daniel-projekt-lead.2474de10.png";